export default {
  instanceSortingCriteria: {
    sortFunctions: {},
    defaultSortFunctionName: '',
  },
};
